// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-DdDc"};